import styles from '../../styles/plan/planHighlights.scss';

const PlanHighlightsNew = (props: any) => (
  <div className="lil-p-2">
    {props.data.map((item: any) => (
      <div>
        <div
          className={`lil-text-center lil-pb-2 lil-text-font-200 lil-text-s-12 ${styles['border-bottom-dotted']} ${styles['label-text']}`}
        >
          {item.label}
        </div>
        <div className="lil-flex lil-pt-2 lil-justify-center lil-items-center">
          <div
            className={`lil-w-5/6  lil-text-s-24 sm:lil-text-s-14 lil-font-semibold ${styles['text-green']}`}
          >
            {parseInt(item.value, 10) > 0 ? (
              <span className="text-green">+{item.value}</span>
            ) : (
              <span className="lil-text-red"> -{item.value}</span>
            )}
          </div>
          <div className="lil-w-1/6 sm:lil-w-full lil-pl-2">
            <img src={item.image} alt="highlight" className="sm:lil-h-2" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default PlanHighlightsNew;



// WEBPACK FOOTER //
// ./components/plan/planHighlightsNew.tsx